export default "__VITE_ASSET__0f8a28bd__"